import images from "./images";


const testimonials = [
    {
        id: 1,
        image: images.testimonial1,
        name: 'John Doe',
        title: 'Homeowner',
        rating: 5,
        content: 'RoofGuard provided outstanding service from start to finish. The installation was professional, and the team was knowledgeable. I\'m extremely satisfied with the results.',
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Sarah Lee',
        title: 'Business Owner',
        rating: 5,
        content: 'The roof repair was quick and efficient, and the team ensured everything was done perfectly. I highly recommend RoofGuard for any roofing needs. They exceeded my expectations.',
    },
    {
        id: 3,
        image: images.testimonial3,
        name: 'Mark Johnson',
        title: 'Property Manager',
        rating: 5,
        content: 'From the initial consultation to the final inspection, RoofGuard Roofing Company was amazing. The quality of their work and attention to detail is unmatched. I couldn’t be more pleased.',
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Anna Smith',
        title: 'Homeowner',
        rating: 5,
        content: 'RoofGuard’s team was professional, courteous, and reliable. They delivered exceptional service, and my new roof looks fantastic. I couldn’t be happier with the results.',
    },
];

export default testimonials;